export enum ContactInquiryStatus {
  New = 0,
  Read = 1,
  Replied = 2,
  Archived = 3,
  Spam = 4,
}

export enum ContactInquirySource {
  Website = 0,
  MobileApp = 1,
  Other = 2,
}

export interface ContactInquiry {
  id: string;
  organizationId: string;
  fullName: string;
  email: string | null;
  phone: string | null;
  subject: string | null;
  message: string;
  status: ContactInquiryStatus;
  source: ContactInquirySource;
  ipAddress: string | null;
  createdAt: string;
  updatedAt: string;
  updatedBy: string | null;
}
